import WindowStack from 'common/WindowStack';

export default function( params ){
  
  return new Promise(function( resolve, reject ){
    
    if( typeof( params ) === 'string' ){
      params = {
        text: params
      };
    }
      
    var options = typeof( params ) !== 'undefined' ? params : {};
    
    options.text = typeof( options.text ) !== 'undefined' ? options.text : '!';
    
    var el = document.createElement('div');
    el.classList.add('confirm-dialog');
    
    var inner = document.createElement('div');
    inner.classList.add('inner');
    
    var buttons = document.createElement('div');
    buttons.classList.add('buttons');
    
    var p = document.createElement('p');
    p.innerText = options.text;
    p.classList.add('text');
    
    inner.appendChild( p );
    inner.appendChild( buttons );
    
    el.appendChild( inner );
    
    var close = function(){
      
      el.classList.add('fadeOut');
      
      setTimeout( function(){
        el.remove();
      }, 200 );
      
    };
        
    var clickTarget = null;
    
    el.addEventListener( 'mousedown', function( e ){
      clickTarget = e.target;
    });
    
    el.addEventListener( 'click', function( e ){
          
      if( e.target === el && e.target == clickTarget ){
        close();
        resolve( false );
      }
      
    });
    
    if( options.buttons ){
      
      options.buttons.forEach( ( button ) => {
        
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.innerText = button.text;
        btn.classList.add('okay');
        
        if( button.onClick ){
    
          btn.addEventListener( 'click', button.onClick );
          
        }
        
        if( button.yes ){
          btn.classList.add('yes');
        }
        
        if( button.no ){
          btn.classList.add('no');
        }
        
        if( button.cancel ){
    
          btn.addEventListener( 'click', function( e ){
            
            close();
            resolve( false );
            
          });
          
        }
        
        buttons.appendChild( btn );
        
      });
      
    }else{
    
      var okay = document.createElement('button');
      okay.type = 'button';
      okay.innerText = 'Okay';
      okay.classList.add('okay');
    
      okay.addEventListener( 'click', function( e ){
        
        close();
        resolve( false );
        
      });

      buttons.appendChild( okay );
      
    }
    
    document.body.appendChild( el );
    
    buttons.querySelector('button').focus();
    
    WindowStack.add( this, function(){
      
      if( el.offsetParent === null ){
        close();
        resolve( false );
      }
      
    });
        
  });

};